// extracted by mini-css-extract-plugin
export default {"root":"root_ChangeIndicator-module_AFAqY","noChangeIcon":"noChangeIcon_ChangeIndicator-module_cComf"};